exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---2tfKJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #cfd2d4;\n  font-size: 20px;\n  width: 100%; }\n  .component---2tfKJ .academicYear---13owX {\n    font-weight: bold;\n    padding-right: 20px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2tfKJ",
	"academicYear": "academicYear---13owX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/header-with-academic-year/header-with-academic-year.scss
// module id = +lTj
// module chunks = 1